import i18n from "i18next";
import { toast } from "sonner";
import { logWarning } from "web_myplann/Infrastructure/sentry";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import { AppRouting } from "web_myplann/Infrastructure/Utils/UrlUtils";
import type {
	NavigationDestination,
	NavigationPayload,
} from "web_myplann/Utils/WebViewHandlers/Types/NotificationNavigationTypes";
import { NavigationDestinationType } from "web_myplann/Utils/WebViewModel";

const DESTINATION_ROUTES: Partial<
	Record<NavigationDestination, (sourceId: string) => string>
> = {
	activity: AppRouting.MyPlann.ActivityDetail.path,
	activityTerm: AppRouting.MyPlann.ActivityDetail.path,
	activityTermNotice: AppRouting.MyPlann.ActivityDetail.path,
	task: AppRouting.MyPlann.TaskDetail.path,
	taskTerm: AppRouting.MyPlann.TaskDetail.path,
	taskTermNotice: AppRouting.MyPlann.TaskDetail.path,
	chat: AppRouting.MyPlann.Chat.Detail.path,
};

export const isWebDestination = (
	type: string | undefined,
): type is NavigationDestination =>
	!!type && Object.hasOwn(NavigationDestinationType, type);

export const getDestinationRoute = (type: string | undefined) =>
	isWebDestination(type) ? DESTINATION_ROUTES[type] : undefined;

const logNavigationIssue = (reason: string, payload: NavigationPayload) =>
	logWarning(reason, {
		notification_type: payload.type,
		notification_id: payload.id,
		notification_source_id: payload.sourceId,
	});

export const fallbackToNotificationList = (
	reason: string,
	payload: NavigationPayload,
	navigate: (path: string) => void,
) => {
	logNavigationIssue(reason, payload);
	toast.error(i18n.t(Resources.Common.somethingWentWrong));
	navigate(AppRouting.MyPlann.Notifications.path());
};

export const navigateToSource = (
	route: (sourceId: string) => string,
	payload: NavigationPayload,
	navigate: (path: string) => void,
) => {
	if (!payload.sourceId) {
		fallbackToNotificationList(
			"Notification navigation without sourceId",
			payload,
			navigate,
		);
		return;
	}
	navigate(route(payload.sourceId));
};
